export enum UrlParamsKeys {
  REDIRECT_TO = "redirectTo",
}
